import React from 'react'
import { M_Table } from 'src/M_Components'

const LogisticsType = ({ roles }) => {
  return (
    <M_Table entityName={'logisticsType'} rolePermissions={roles} />
  )
}

export default LogisticsType